module.exports = __webpack_public_path__ + "img/repair_card2.08cb2100.png";